import React from 'react';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// 알림톡 전달 과정에서 customre로 오타난 경우를 대비한 페이지입니다.
// customer로 리다이렉트시킵니다.
export function CustomerRedirectPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const orderUrl = `/customer/orders/${id}`;
    navigate(orderUrl);
  }, []);

  return <React.Fragment />;
}
